import React from 'react';
import './Pagination.css';
import arrowLeft from '../images/assets/Arrow-left.svg';
import arrowRight from '../images/assets/Arrow-right.svg';

function Pagination({ currentPage, totalItems, pageSize, onPageChange }) {
    const totalPages = Math.ceil(totalItems / pageSize);

    if (totalPages <= 1) return null;

    const getMaxVisible = () => {
        if (typeof window === 'undefined') return 7;
        return window.innerWidth < 640 ? 5 : 9; // phone vs tablet/desktop
    };

    const maxVisible = getMaxVisible();

    const getPageNumbers = () => {
        const pages = [];
        const sidePages = Math.floor((maxVisible - 3) / 2); // pages on each side of current

        // Always show first page
        pages.push(1);

        // Left ellipsis
        if (currentPage > sidePages + 2) {
            pages.push('...');
        }

        // Pages around current
        const start = Math.max(2, currentPage - sidePages);
        const end = Math.min(totalPages - 1, currentPage + sidePages);

        for (let i = start; i <= end; i++) {
            pages.push(i);
        }

        // Right ellipsis
        if (currentPage < totalPages - sidePages - 1) {
            pages.push('...');
        }

        // Always show last page (if not already included)
        if (totalPages > 1 && end < totalPages) {
            pages.push(totalPages);
        }

        return pages;
    };

    return (
        <div className="pagination">
            <button
                onClick={() => onPageChange(currentPage - 1)}
                disabled={currentPage === 1}
            >
                <img src={arrowLeft} className='pagination-arrow' />
            </button>

            {getPageNumbers().map((page, idx) => (
                <button
                    key={idx}
                    onClick={() => typeof page === 'number' && onPageChange(page)}
                    className={`page-btn ${page === currentPage ? 'active' : ''} ${page === '...' ? 'ellipsis' : ''
                        }`}
                    disabled={page === '...'}
                >
                    {page}
                </button>
            ))}

            <button
                onClick={() => onPageChange(currentPage + 1)}
                disabled={currentPage === totalPages}
            >
                <img src={arrowRight} />
            </button>
        </div>
    );
}

export default Pagination;